var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c(
              "b-button",
              {
                attrs: { "icon-left": "arrow-left" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v(" Back ")]
            ),
          ],
          1
        ),
        _vm.fileImportProperty && _vm.partner
          ? _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c("p", { staticClass: "title is-4" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.partner.id) +
                        " - " +
                        _vm._s(_vm.partner.name) +
                        " "
                    ),
                  ]),
                  _c("b-loading", {
                    model: {
                      value: _vm.isLoading,
                      callback: function ($$v) {
                        _vm.isLoading = $$v
                      },
                      expression: "isLoading",
                    },
                  }),
                  _c(
                    "b-message",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasWarning,
                          expression: "hasWarning",
                        },
                      ],
                      attrs: { type: "is-warning", "has-icon": "" },
                    },
                    [
                      _vm._v(" Attention: this client has "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.pendingShippings.length) + " "),
                      ]),
                      _vm._v(
                        " pending shippments, please go to partner web portal: "
                      ),
                      _c("br"),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://partner.fr-gps.com/shippingManagement",
                          },
                        },
                        [
                          _vm._v(
                            "https://partner.fr-gps.com/shippingManagement"
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "b-field",
                    { attrs: { grouped: "", "group-multiline": "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c(
                            "b-taglist",
                            { attrs: { attached: "" } },
                            [
                              _c("b-tag", { attrs: { type: "is-dark" } }, [
                                _vm._v(" Format "),
                              ]),
                              _c("b-tag", { attrs: { type: "is-primary" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.fileImportProperty.dateFormat) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c(
                            "b-taglist",
                            { attrs: { attached: "" } },
                            [
                              _c("b-tag", { attrs: { type: "is-dark" } }, [
                                _vm._v(" Delimiter "),
                              ]),
                              _c("b-tag", { attrs: { type: "is-primary" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.fileImportProperty.delimiter) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c(
                            "b-taglist",
                            { attrs: { attached: "" } },
                            [
                              _c("b-tag", { attrs: { type: "is-dark" } }, [
                                _vm._v(" Type "),
                              ]),
                              _c("b-tag", { attrs: { type: "is-primary" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.fileImportProperty.table) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c(
                            "b-taglist",
                            { attrs: { attached: "" } },
                            [
                              _c("b-tag", { attrs: { type: "is-dark" } }, [
                                _vm._v(" Parser "),
                              ]),
                              _c("b-tag", { attrs: { type: "is-primary" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.fileImportProperty.parser) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c(
                            "b-taglist",
                            { attrs: { attached: "" } },
                            [
                              _c("b-tag", { attrs: { type: "is-dark" } }, [
                                _vm._v(" Has header "),
                              ]),
                              _c("b-tag", { attrs: { type: "is-primary" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.fileImportProperty.hasHeader) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        "icon-left": "plus",
                        type: "is-info",
                        size: "is-small",
                      },
                      on: {
                        click: function ($event) {
                          _vm.upload.isOpen = true
                        },
                      },
                    },
                    [_vm._v(" Upload file ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "1rem" },
                      attrs: {
                        "icon-left": "check",
                        type: "is-success",
                        size: "is-small",
                      },
                      on: { click: _vm.integrateAllFiles },
                    },
                    [_vm._v(" Integrate all non-integrated files ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "1rem" },
                      attrs: {
                        "icon-left": "magnifying-glass",
                        type: "is-success",
                        size: "is-small",
                      },
                      on: { click: _vm.getErrorTypes },
                    },
                    [_vm._v(" See error list ")]
                  ),
                ],
                1
              ),
              _c("ag-grid-vue", {
                staticClass: "ag-theme-alpine",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  "row-data": _vm.files,
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "animate-rows": true,
                  "row-selection": "multiple",
                  "pagination-auto-page-size": true,
                  "side-bar": _vm.sideBar,
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                },
                on: {
                  "grid-ready": _vm.gridReady,
                  "first-data-rendered": _vm.firstDataRendered,
                  rowClicked: _vm.rowClicked,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            scroll: "keep",
            "has-modal-card": "",
            active: _vm.upload.isOpen,
          },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.upload, "isOpen", $event)
            },
            close: function ($event) {
              _vm.upload.dropFiles = []
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-card",
              staticStyle: { "min-height": "560px" },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _vm._v(" Upload files "),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Files" } },
                    [
                      _c(
                        "b-upload",
                        {
                          attrs: {
                            loading: _vm.upload.isLoading,
                            multiple: "",
                            accept: ".txt, .csv, .xlsx",
                            "drag-drop": "",
                          },
                          model: {
                            value: _vm.upload.dropFiles,
                            callback: function ($$v) {
                              _vm.$set(_vm.upload, "dropFiles", $$v)
                            },
                            expression: "upload.dropFiles",
                          },
                        },
                        [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              { staticClass: "content has-text-centered" },
                              [
                                _c(
                                  "p",
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "file", size: "is-large" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("p", [
                                  _vm._v(
                                    "Drop your files here or click to select files"
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "tags" },
                    _vm._l(_vm.upload.dropFiles, function (file, index) {
                      return _c(
                        "span",
                        { key: index, staticClass: "tag is-info" },
                        [
                          _vm._v(" " + _vm._s(file.name) + " "),
                          _c("button", {
                            staticClass: "delete is-small",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteDropFile(index)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          type: "info",
                          "icon-left": "upload",
                          disabled: !_vm.upload.dropFiles.length,
                          loading: _vm.upload.isLoading,
                        },
                        on: { click: _vm.uploadFiles },
                      },
                      [_vm._v(" Upload ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isLookingAtErrors,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isLookingAtErrors = $event
            },
          },
        },
        [
          _vm.isLookingAtErrors
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "modal-card",
                    staticStyle: {
                      "min-width": "50vw",
                      width: "fit-content",
                      "min-height": "50vh",
                      height: "fit-content",
                    },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v(" Error summary "),
                      ]),
                    ]),
                    _c(
                      "section",
                      { staticClass: "modal-card-body" },
                      _vm._l(_vm.filesInError, function (file, index) {
                        return _c(
                          "div",
                          {
                            key: index + "file",
                            staticStyle: {
                              "background-color": "white",
                              "padding-left": "1rem",
                              "padding-top": "0.5rem",
                              "padding-bottom": "0.5rem",
                              "margin-top": "0.5rem",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v(" " + _vm._s(file.filename) + " ")]
                            ),
                            _vm._l(file.errors, function (error, eIndex) {
                              return _c("div", { key: eIndex + "error" }, [
                                error === "Invalid consignee"
                                  ? _c(
                                      "div",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "row",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(" " + _vm._s(error) + " "),
                                            ]),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "2rem",
                                                },
                                              },
                                              _vm._l(
                                                file.invalidConsignees,
                                                function (consignee, cIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        cIndex +
                                                        "consigneeCode",
                                                      staticClass: "pl-1 pr-1",
                                                      staticStyle: {
                                                        "background-color":
                                                          "#6abf9e",
                                                        "border-radius": "25px",
                                                        color: "white",
                                                        width: "fit-content",
                                                        "margin-bottom": "2px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            consignee.GPS_CONSIGNEE
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c("div", [
                                      _vm._v(" " + _vm._s(error) + " "),
                                    ]),
                              ])
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }